/* eslint-disable react/prop-types */
import React from "react";
import { Box, Grid } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import { getCurrentTimeForDate, getStatus, getDurationForEvent } from "./utils";
import AlarmOffIcon from "@material-ui/icons/AlarmOff";
import { DEFAULT_EXCEPTION } from "config";
import { useTranslation } from "react-i18next";
import { properCase } from "utils";


const EventContent = (props) => {
  const { eventInfo } = props;
  // console.log("boho", eventInfo);
  const { t } = useTranslation();
  const data = eventInfo.event.extendedProps;
  // console.log("eventInfo:event:extendedProps", eventInfo.event.extendedProps);
  const theme = useTheme();

  React.useEffect(() => {
    const interval = setInterval(() => {
      if (data.status == "new" && !data.outLocalTS) {
        const current = getCurrentTimeForDate(eventInfo.event.start);
        eventInfo.event.setEnd(current);
      }
    }, [1000]);

    return () => interval && clearInterval(interval);
  }, [eventInfo]);

  const jobFamily = data.jobfamily || data.jobName;
  const buildingId = data.buildingId;
  let exception = data.exception || data.exceptionName;
  if (exception == DEFAULT_EXCEPTION) {
    exception = "";
  }

  return (
    <>
      <Box className="fc-event-main-frame">
        <Box className="fc-event-time" style={{ color: "white" }}>
          {eventInfo.timeText}
        </Box>
        <Box className="fc-event-title-container">
          <Box className="fc-event-title fc-sticky" style={{ color: "white" }}>
            {`${jobFamily ? jobFamily + " - " : ""} ${buildingId}`}
            {eventInfo.timeText != ""
              ? ` (${getDurationForEvent(eventInfo.timeText)}hrs)`
              : ""}
          </Box>
        </Box>
        {!eventInfo.isMirror && (
          <Box
            className="fc-event-main-frame"
            style={{
              position: "absolute",
              right: 0,
              top: 0,
              fontSize: "inherit",
              color: "#fff",
              borderRadius: theme.shape.borderRadius,
              paddingBottom: 5,
            }}
            px={0.5}
            component="span"
          >
            <Grid container spacing={1}>
              <Grid item>{exception && <AlarmOffIcon fontSize="small" />}</Grid>
              <Grid item>{ getStatus(data) === "Approved" ? 
                            properCase(t("other.lblApproved")) :
                            getStatus(data) === "Pending" ?
                            properCase(t("other.lblPending")) :
                            getStatus(data) === "In Progress" ?
                            properCase(t("other.tlinProgress")) :
                            getStatus(data) === "Auto Completed" ?
                            properCase(t("other.lblAutoComplete")) :  
                            getStatus(data) === "Auto Approved" ?
                            properCase(t("other.lblAutoApproved")) :                                                                                  
                            getStatus(data)
                           }</Grid>
            </Grid>
          </Box>
        )}
      </Box>
    </>
  );
};

export default EventContent;
